import styled from "styled-components";

interface CardProps {
  borderRadius?: string
}

export const Card = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  background-color: #ffffff;
  border-radius: ${({ borderRadius }: CardProps) => borderRadius};
  border-color: rgba(229, 231, 235, 1);
  width: 100%;
  @media (min-width: 1024px) {
    padding-left: 40px;
    padding-right: 40px;
  };
  @media (max-width: 768px) {
    border-radius: 0px;
  };
`;
